import { render, staticRenderFns } from "./Roompad.vue?vue&type=template&id=304022ce&scoped=true"
import script from "./Roompad.vue?vue&type=script&lang=js"
export * from "./Roompad.vue?vue&type=script&lang=js"
import style0 from "./Roompad.vue?vue&type=style&index=0&id=304022ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304022ce",
  null
  
)

export default component.exports